import React, { useMemo } from 'react';

import { useUIContext } from 'lib/context/UIContext/UIContext';
import { ia } from 'lib/helpers/utility';

import TableRow from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceTable/components/TableRow';
import Typography from 'components/shared/Typography/Typography';

import DescriptionHeaderCell from '../ReceiptItems/DescriptionHeaderCell';

import TableCell from './components/TableCell';
import TableFooter from './components/TableFooter';
import TableFooterSummary from './components/TableFooterSummary';
import TableHeaderRow from './components/TableHeaderRow';

import './ReceiptTable.scss';

const ReceiptTable = ({
  index,
  items,
  columns,
  footer,
  dateOfService,
  totals,
  hasMultipleTransactions
}) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  const visibleColumns = useMemo(() => columns.filter((col) => !col.hide), [columns]);

  const hasItems = useMemo(() => ia(items), [items]);

  return (
    <table className="receipt-table h-fit w-full table-fixed">
      {!isMobile && (
        <colgroup>
          {visibleColumns.map((col, idx) => (
            <col
              key={idx}
              style={{
                minWidth: col.minWidth,
                width: col.width || `${100 / visibleColumns.length}%`
              }}
            />
          ))}
        </colgroup>
      )}
      {index === 0 && (
        <thead>
          <TableHeaderRow columnDefs={visibleColumns} preview={true} small />
        </thead>
      )}
      <tbody>
        {dateOfService && (
          <DescriptionHeaderCell dateOfService={dateOfService} colSpan={visibleColumns.length} />
        )}
        {hasItems ? (
          items.map((item, index) => (
            <TableRow
              key={item.name + index}
              row={item}
              columnDefs={visibleColumns}
              className="border-0 border-b border-solid border-neutral-200 px-6 sm:px-2"
              cellClassName="px-0"
              idx={index}
              preview
            />
          ))
        ) : (
          <tr className="h-fit w-fit border-0 border-b border-solid border-neutral-200">
            <TableCell
              colSpan={visibleColumns.length}
              className="items-center"
              bodyClassName="h-20 justify-center items-center">
              <Typography variant="label" size="medium" weight="medium" color="neutral-700">
                No items found
              </Typography>
            </TableCell>
          </tr>
        )}
      </tbody>
      {!isMobile && ia(items) && footer && (
        <tfoot>
          <TableFooter columnDefs={visibleColumns} rowData={items} />
          {hasMultipleTransactions && (
            <TableFooterSummary colSpan={visibleColumns.length} totals={totals} />
          )}
        </tfoot>
      )}
    </table>
  );
};

export default ReceiptTable;
